import {
  CREATE_COINS_URL,
  UPDATE_COINS_URL,
  DELETE_COINS_URL,
  GET_COINS_URL,
  GET_XP_URL,
  CREATE_XP_URL,
  UPDATE_XP_URL,
  DELETE_XP_URL,
} from "../apiurls/apiurls";

const getHeaders = (token) => ({
  "Content-Type": "application/json",
  Authorization: token,
});

export const getCoins = async (token, courseId, type) => {
  let url = type === "coins" ? `${GET_COINS_URL}` : `${GET_XP_URL}`;
  const res = await fetch(`${url}?course_id=${courseId}`, {
    method: "GET",
    headers: getHeaders(token),
  });

  if (!res.ok) throw new Error("Failed to fetch coins");
  return res.json();
};

export const createCoins = async (payload, token, type) => {
  let url = type === "coins" ? `${CREATE_COINS_URL}` : `${CREATE_XP_URL}`;
  const res = await fetch(url, {
    method: "POST",
    headers: getHeaders(token),
    body: JSON.stringify(payload),
  });

  if (!res.ok) throw new Error("Failed to create coins");
  return res.json();
};

export const updateCoins = async (payload, token, courseId, type) => {
  let url = type === "coins" ? `${UPDATE_COINS_URL}` : `${UPDATE_XP_URL}`;
  const res = await fetch(`${url}?course_id=${courseId}`, {
    method: "PUT",
    headers: getHeaders(token),
    body: JSON.stringify(payload),
  });

  if (!res.ok) throw new Error("Failed to update coins");
  return res.json();
};

export const deleteCoins = async (token, courseId, type) => {
  let url = type === "coins" ? `${DELETE_COINS_URL}` : `${DELETE_XP_URL}`;
  const res = await fetch(`${url}?course_id=${courseId}`, {
    method: "DELETE",
    headers: getHeaders(token),
  });

  if (!res.ok) throw new Error("Failed to delete coins");
  return res.json();
};
